/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TFOutputResponseDTO } from '../models/tfoutput-response-dto';
import { TFOutputRequestDTO } from '../models/tfoutput-request-dto';

/**
 * Ui Tf Output Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiTfOutputControllerService extends __BaseService {
  static readonly getAllOutputsUsingGETPath = '/cc-ui/v1/tf-outputs';
  static readonly createOrUpdateOutputUsingPOSTPath = '/cc-ui/v1/tf-outputs';
  static readonly getOutputsByProviderSourceUsingGETPath =
    '/cc-ui/v1/tf-outputs/provider';
  static readonly getOutputByNameUsingGETPath = '/cc-ui/v1/tf-outputs/{name}';
  static readonly deleteOutputUsingDELETEPath = '/cc-ui/v1/tf-outputs/{name}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllOutputs
   * @return OK
   */
  getAllOutputsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<TFOutputResponseDTO>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/tf-outputs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TFOutputResponseDTO>>;
      }),
    );
  }
  /**
   * getAllOutputs
   * @return OK
   */
  getAllOutputsUsingGET(): __Observable<Array<TFOutputResponseDTO>> {
    return this.getAllOutputsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<TFOutputResponseDTO>),
    );
  }

  /**
   * createOrUpdateOutput
   * @param requestDTO requestDTO
   * @return OK
   */
  createOrUpdateOutputUsingPOSTResponse(
    requestDTO: TFOutputRequestDTO,
  ): __Observable<__StrictHttpResponse<TFOutputResponseDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = requestDTO;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/tf-outputs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TFOutputResponseDTO>;
      }),
    );
  }
  /**
   * createOrUpdateOutput
   * @param requestDTO requestDTO
   * @return OK
   */
  createOrUpdateOutputUsingPOST(
    requestDTO: TFOutputRequestDTO,
  ): __Observable<TFOutputResponseDTO> {
    return this.createOrUpdateOutputUsingPOSTResponse(requestDTO).pipe(
      __map((_r) => _r.body as TFOutputResponseDTO),
    );
  }

  /**
   * Get all outputs that use a specific provider source
   * @param source Provider source name
   * @return OK
   */
  getOutputsByProviderSourceUsingGETResponse(
    source: string,
  ): __Observable<__StrictHttpResponse<Array<TFOutputResponseDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (source != null) __params = __params.set('source', source.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/tf-outputs/provider`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TFOutputResponseDTO>>;
      }),
    );
  }
  /**
   * Get all outputs that use a specific provider source
   * @param source Provider source name
   * @return OK
   */
  getOutputsByProviderSourceUsingGET(
    source: string,
  ): __Observable<Array<TFOutputResponseDTO>> {
    return this.getOutputsByProviderSourceUsingGETResponse(source).pipe(
      __map((_r) => _r.body as Array<TFOutputResponseDTO>),
    );
  }

  /**
   * getOutputByName
   * @param params The `UiTfOutputControllerService.GetOutputByNameUsingGETParams` containing the following parameters:
   *
   * - `namespace`: namespace
   *
   * - `name`: name
   *
   * @return OK
   */
  getOutputByNameUsingGETResponse(
    params: UiTfOutputControllerService.GetOutputByNameUsingGETParams,
  ): __Observable<__StrictHttpResponse<TFOutputResponseDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.namespace != null)
      __params = __params.set('namespace', params.namespace.toString());

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/tf-outputs/${encodeURIComponent(String(params.name))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TFOutputResponseDTO>;
      }),
    );
  }
  /**
   * getOutputByName
   * @param params The `UiTfOutputControllerService.GetOutputByNameUsingGETParams` containing the following parameters:
   *
   * - `namespace`: namespace
   *
   * - `name`: name
   *
   * @return OK
   */
  getOutputByNameUsingGET(
    params: UiTfOutputControllerService.GetOutputByNameUsingGETParams,
  ): __Observable<TFOutputResponseDTO> {
    return this.getOutputByNameUsingGETResponse(params).pipe(
      __map((_r) => _r.body as TFOutputResponseDTO),
    );
  }

  /**
   * deleteOutput
   * @param params The `UiTfOutputControllerService.DeleteOutputUsingDELETEParams` containing the following parameters:
   *
   * - `namespace`: namespace
   *
   * - `name`: name
   */
  deleteOutputUsingDELETEResponse(
    params: UiTfOutputControllerService.DeleteOutputUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.namespace != null)
      __params = __params.set('namespace', params.namespace.toString());

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/tf-outputs/${encodeURIComponent(String(params.name))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteOutput
   * @param params The `UiTfOutputControllerService.DeleteOutputUsingDELETEParams` containing the following parameters:
   *
   * - `namespace`: namespace
   *
   * - `name`: name
   */
  deleteOutputUsingDELETE(
    params: UiTfOutputControllerService.DeleteOutputUsingDELETEParams,
  ): __Observable<null> {
    return this.deleteOutputUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }
}

module UiTfOutputControllerService {
  /**
   * Parameters for getOutputByNameUsingGET
   */
  export interface GetOutputByNameUsingGETParams {
    /**
     * namespace
     */
    namespace: string;

    /**
     * name
     */
    name: string;
  }

  /**
   * Parameters for deleteOutputUsingDELETE
   */
  export interface DeleteOutputUsingDELETEParams {
    /**
     * namespace
     */
    namespace: string;

    /**
     * name
     */
    name: string;
  }
}

export { UiTfOutputControllerService };
